import { configureStore } from '@reduxjs/toolkit';
import onBoardingReducer from './onBoardingSlice.js';
import authReducer from './authSlice.js';
import promptReducer from '../redux/promptSlice.js';
import fontListReducer from '../redux/fontListSlice.js';
import createImageReducer from '../redux/createImageSlice.js';
import pastCreationReducer from '../redux/pastCreateionsSlice.js';
import toasterReducer from '../redux/toasterSlice.js';
import adminSlice from '../redux/adminSlice.js';
import adminDashboardReducer from '../redux/adminDashboardSlice.js';
import uploadImageReducer from '../redux/uploadImageSlice.js';
import imageModalReducer from '../redux/imageModalSlice.js';
import promptSuggestionReducer from '../redux/promptSuggestion.js';

const store = configureStore({
  reducer: {
    onBoarding: onBoardingReducer,
    auth: authReducer,
    toaster: toasterReducer,
    prompt: promptReducer,
    fontList: fontListReducer,
    createImage: createImageReducer,
    pastCreation: pastCreationReducer,
    admin: adminSlice,
    adminDashboard: adminDashboardReducer,
    uploadImage: uploadImageReducer,
    imageModalData: imageModalReducer,
    promptSuggestion: promptSuggestionReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export default store;
